// extracted by mini-css-extract-plugin
module.exports = {"miniCardWrapper":"mini-card_miniCardWrapper__8EFgo","image":"mini-card_image__TCREX","selected":"mini-card_selected__WkpcV"};